import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  mainContainer: {
    marginTop: 93
    // width: "100%"
  },
  sectionContainer: { display: "flex", justifyContent: "center" },
  sectionText: {
    width: "633px",
    margin: "49px 13px 64px 11px",
    fontFamily: "Trebuchet",
    fontSize: "38px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.59px",
    textAlign: "center",
    color: "rgba(0, 0, 0, 0.87)",
    [theme.breakpoints.down("sm")]: {
      fontSize: "26px"
    }
  },
  titleSlider: {
    width: "410px",
    height: "60px",
    borderRadius: "10px",
    backgroundColor: "#0073cf",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "26px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center",
    color: "rgba(255, 255, 255, 0.87)",
    position: "relative",
    marginLeft: "auto",
    marginRight: "auto",
    top: "30px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
      width: "80%"
    }
  }
}));

export default styles;
